module.exports = __webpack_public_path__ + "img/derecho-civil.0b5f37b5.svg";